const jhspanthercubWidgetData = [
  {
    songTitle: "Chase Delay",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_panthercub_chase_delay_on.mp3?v=1743984555",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_panthercub_chase_delay_off.mp3?v=1743984555",
    video: "https://cdn.shopify.com/videos/c/o/v/ae45139616484f27975bebe7beba6111.mp4"
  },
  {
    songTitle: "Galloping Delay",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_panthercub_galloping_delay_on.mp3?v=1743984556",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_panthercub_galloping_delay_off.mp3?v=1743984556",
    video: "https://cdn.shopify.com/videos/c/o/v/6460ee0c7ddd481c865f1c77dfac3003.mp4"
  },
  {
    songTitle: "Slap",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_panthercub_slap_on.mp3?v=1743984556",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_panthercub_slap_off.mp3?v=1743984555",
    video: "https://cdn.shopify.com/videos/c/o/v/6ac346ec1bab43149d114afc48018624.mp4"
  },
  {
    songTitle: "Vocal Delay",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_panthercub_vocal_delay_on.mp3?v=1743984556",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_panthercub_vocal_delay_off.mp3?v=1743984556",
    video: "https://cdn.shopify.com/videos/c/o/v/f08234b81eb14d82a828305f2c3ee6af.mp4"
  }
];
